"use client";

import { type Messages, setupI18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { useState } from "react";

type LinguiClientProviderProps = {
	children: React.ReactNode;
	locale: string;
	messages: Messages;
};

export const LinguiClientProvider = ({ children, locale, messages }: LinguiClientProviderProps) => {
	const [i18n] = useState(() => setupI18n({ locale, messages: { [locale]: messages } }));
	return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
};
